import type { ReactNode } from 'react'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export function BarListRow({
	label,
	displayValue,
	widthPct,
	colorClass,
	muted,
	tooltip,
	onClick,
}: {
	label: string
	displayValue: string
	widthPct: number
	colorClass: string
	muted?: boolean
	tooltip?: ReactNode
	onClick?: () => void
}) {
	const row = (
		<div
			className={cn(
				'grid grid-cols-[1fr_2fr_auto] items-center gap-2.5',
				onClick && 'cursor-pointer rounded hover:bg-kaefer-light-silver/30',
			)}
			onClick={onClick}
			onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
			role={onClick ? 'button' : undefined}
			tabIndex={onClick ? 0 : undefined}
		>
			<span
				className={cn(
					'truncate text-xs',
					muted ? 'text-muted-foreground' : 'text-kaefer-dark-grey',
				)}
				title={label}
			>
				{label}
			</span>
			<div className="h-3.5 overflow-hidden bg-kaefer-light-silver/60">
				<div
					className={cn('h-full', colorClass)}
					style={{ width: `${Math.max(widthPct, 2)}%` }}
				/>
			</div>
			<span className="text-right text-xs font-semibold text-muted-foreground tabular-nums">
				{displayValue}
			</span>
		</div>
	)

	if (!tooltip) return row

	return (
		<Tooltip>
			<TooltipTrigger asChild>{row}</TooltipTrigger>
			<TooltipContent>{tooltip}</TooltipContent>
		</Tooltip>
	)
}
